import { CreateUserFormValues } from '@client-ui/components/forms/create-user-form/create-user.form';
import { ErrorModel } from '@shared-lib/models/error.model';

export interface SignUpUserState {
  entity: CreateUserFormValues | null;
  loading: boolean;
  errors: ErrorModel | null;
}

export const signUpUserSelectorName = 'signUpUser';
